<script setup lang="ts">
defineOptions({ name: 'AnimationScanTicket' })

const numbers = [5, 56, 46, 69, 12, 34, 27, 51, 8, 42, 19, 75]
const { t: $t } = useI18n()

const scanProgress = ref(-0.3)

onMounted(() => {
	let start: number | null = null
	const duration = 2400

	const tick = (ts: number) => {
		if (!start) start = ts
		const elapsed = (ts - start) % (duration * 2)
		scanProgress.value = elapsed < duration ? elapsed / duration - 0.3 : 1.3 - (elapsed - duration) / duration
		requestAnimationFrame(tick)
	}
	requestAnimationFrame(tick)
})

const getBubbleStyle = (index: number) => {
	const bubblePos = index / (numbers.length - 1)
	const diff = Math.abs(scanProgress.value - bubblePos)
	const isLit = diff < 0.08 && scanProgress.value >= 0 && scanProgress.value <= 1

	return {
		animationDelay: `${index * 0.18}s`,
		background: isLit ? 'oklch(0.95 0.18 90)' : 'rgba(255,255,255,0.2)',
		color: isLit ? '#1a1a1a' : 'white',
		boxShadow: isLit ? '0 0 12px 3px oklch(0.9 0.2 90)' : 'none',
		transition: 'background 0.3s ease, box-shadow 0.3s ease, color 0.3s ease',
	}
}

const lineStyle = computed(() => ({
	top: `${scanProgress.value * 100}%`,
}))
</script>

<template>
	<div class="flex-1 flex h-screen bg-success-600 sm:bg-primary-600">
		<div class="container mx-auto">
			<div class="flex flex-col justify-center items-center py-10 gap-8">
				<div
					class="relative w-80 overflow-hidden rounded-2xl border-2 border-white/40 bg-white/15 p-6 backdrop-blur-sm"
				>
					<p class="text-center text-[11px] tracking-[0.3em] text-white/80 mb-5">✦ SCANNING ✦</p>

					<div class="grid grid-cols-4 gap-3 place-items-center">
						<span
							v-for="(num, i) in numbers"
							:key="i"
							class="w-12 h-12 flex items-center justify-center rounded-full text-[15px] font-bold animate-number-scan"
							:style="getBubbleStyle(i)"
						>
							{{ String(num).padStart(2, '0') }}
						</span>
					</div>

					<div
						class="absolute inset-x-0 h-[3px] rounded-full pointer-events-none"
						:style="[lineStyle, { background: 'oklch(0.95 0.18 90)', boxShadow: '0 0 18px 4px oklch(0.9 0.2 90)' }]"
					/>
				</div>

				<h2 class="text-2xl font-bold text-white animate-soft-pulse">
					{{ $t('Preparing the scanning for you') }}
				</h2>
				<p class="max-w-md text-center text-white/90 text-sm">
					{{ $t(`We're analyzing 1,000,000+ data points to find your lucky numbers`) }}!
				</p>
			</div>
		</div>
	</div>
</template>

<style scoped>
@keyframes number-scan {
	0%,
	100% {
		opacity: 0.4;
		transform: scale(0.88);
	}
	50% {
		opacity: 1;
		transform: scale(1.08);
	}
}
@keyframes soft-pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.65;
	}
}
</style>
